import React, { useState, useEffect } from 'react'
import useModal from 'hook/useModal'

// css
import 'assets/style/elements/search-bar.scss'

// elements
import TextInput from 'components/elements/TextInput'
import Label from 'components/elements/Label'
import Button from 'components/elements/Button'

function Element({
  className,
  children,
  goSearch = () => {},
  title = '검색어',
  placeholder = '검색어를 입력하세요.',
  comment = '',
}) {
  const [text, setText] = useState('') // 검색어

  const onChange = (e) => {
    setText(e.target.value)
    console.log('타이핑 : ', e.target.value)
  }

  const onKeyUp = (e) => {
    if (e.key === 'Enter') goSearch(text)
  }

  return (
    <div className={`wrapper ${className}`}>
      <ul className="vertical-form-group mt16">
        {children}
        <li key="label">
          <Label text={title} />
          <TextInput value={text} placeholder={placeholder} onChange={onChange} onKeyUp={onKeyUp} />
        </li>
      </ul>
      {/* todo: 버튼 풀 사이즈 css */}
      <div className="flex mt16">
        <Button text="검색" color="primary" className="full" onClick={() => goSearch(text)} />
      </div>
      {comment}
    </div>
  )
}

export default Element
